import { Check, X } from 'lucide-react'
import { Button, Modal } from 'react-bootstrap'

export function Confirm({ children, onAccept, onReject, className, ...props }) {
    return (
        <Modal dialogClassName='w-25rem' {...props} centered>
            <Modal.Header className='py-2'>
                <Modal.Title>Confirmar</Modal.Title>
            </Modal.Header>
            <div className='px-3 py-2'>
                <div className='flex items-center gap-3'>
                    <span
                        class='bi-question-circle-fill text-primary'
                        style={{ fontSize: '2.5rem' }}
                    />
                    <div>{children}</div>
                </div>
            </div>
            <Modal.Footer className='py-2'>
                <Button variant='outline-primary' className='w-20' onClick={onReject}>
                    <X className='size-4' />
                    No
                </Button>
                <Button className='w-20' onClick={onAccept}>
                    <Check className='size-4' />
                    Si
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
